const ROLES = { admin: 'Dynamic BPO', cliente: 'Cliente', agente: 'Operación' };

// Small inline icons (no dependency) so the sidebar reads like a real app nav.
const ICONOS = {
  panel: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>,
  pacientes: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M17 8.2a3 3 0 0 1 0 5.6"/><path d="M18.5 20a5 5 0 0 0-3-4.6"/></svg>,
  cargar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15V4"/><path d="m7.5 8.5 4.5-4.5 4.5 4.5"/><path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>,
};

// Sidebar shell for the portal. `activo` is the current view id; `onNav(id)`
// switches views; `onSalir` signs out.
export default function Marco({ perfil, activo, onNav, onSalir, children }) {
  const enlaces = [['panel', 'Tablero'], ['pacientes', 'Pacientes'], ['cargar', 'Cargar archivo']];

  return (
    <div className="shell">
      <aside className="side">
        <div className="brand">
          <div className="logo">D</div>
          <div>
            <div className="bt">DYNAMIC BPO</div>
            <div className="bs">TU EQUIPO · TU MISIÓN</div>
          </div>
        </div>

        {enlaces.map(([id, texto]) => (
          <button key={id} className={'snav' + (activo === id ? ' on' : '')} onClick={() => onNav(id)}>
            {ICONOS[id]} {texto}
          </button>
        ))}

        <div className="sidecard">
          <div className="h">{perfil?.nombre || perfil?.email}</div>
          <div className="s">{ROLES[perfil?.rol] || perfil?.rol}</div>
          <div className="p">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="var(--verde)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="m9 12 2 2 4-4"/></svg>
            Datos protegidos
          </div>
          <button className="btn" style={{ width: '100%', marginTop: 11 }} onClick={onSalir}>Salir</button>
        </div>
      </aside>

      <main className="main">{children}</main>
    </div>
  );
}
